import { render, staticRenderFns } from "./FjsportsSampleView.vue?vue&type=template&id=1ed8bc12&scoped=true&"
import script from "./FjsportsSampleView.vue?vue&type=script&lang=js&"
export * from "./FjsportsSampleView.vue?vue&type=script&lang=js&"
import style0 from "./FjsportsSampleView.vue?vue&type=style&index=0&id=1ed8bc12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8bc12",
  null
  
)

export default component.exports